// Loose equality for form values: treats '', undefined and null as equal, and
// compares scalars with == so that e.g. a retyped number ('5') matches its
// original (5). Recurses into arrays and plain objects.
export const looseValueEqual = (a: unknown, b: unknown): boolean => {
  const empty = ['', undefined, null] as const;
  if (empty.includes(a as never) && empty.includes(b as never)) {
    return true;
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) {
      return false;
    }
    return a.every((item, idx) => looseValueEqual(item, b[idx]));
  }

  if (typeof a === 'object' && typeof b === 'object' && a !== null && b !== null) {
    const objA = a as Record<string, unknown>;
    const objB = b as Record<string, unknown>;
    const keys = new Set([...Object.keys(objA), ...Object.keys(objB)]);
    for (const key of keys) {
      if (!looseValueEqual(objA[key], objB[key])) {
        return false;
      }
    }
    return true;
  }

  return a == b;
};
